<template>
  <q-scroll-area
      ref="scroll"
      v-bind="$attrs"
      class="scroll-area"
      visible
      :thumb-style="thumbStyle"
      content-style="max-width:100%"
  >
    <slot />
  </q-scroll-area>
</template>

<script>
import { getCssVar } from 'quasar'

export default {
  setup () {
    return {
      thumbStyle: {
        right: '2px',
        borderRadius: '5px',
        backgroundColor: getCssVar('primary'),
        width: '5px',
        opacity: 0.75,
      },
    }
  },
}
</script>
